<template>
    <svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.095 11.5H14v7h-3v-7H9v-2h2V8.336c0-1.099.352-2.818 2.65-2.818l2.35.006V7.83h-1.408c-.244 0-.592.124-.592.647V9.5h2.339l-.244 2zM12.5 0C5.883 0 .5 5.383.5 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12z" fill="#FFF" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFacebook',
};
</script>

